export const partial = (fn: Function, ...args) => {
  if (fn.length <= args.length) {
    return fn(...args);
  } else {
    return (...moreArgs) => partial(fn, ...[...args, ...moreArgs]);
  }
};
